import { render, staticRenderFns } from "./result.vue?vue&type=template&id=1cd67324&scoped=true&"
import script from "./result.vue?vue&type=script&lang=js&"
export * from "./result.vue?vue&type=script&lang=js&"
import style0 from "./result.vue?vue&type=style&index=0&id=1cd67324&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd67324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd67324')) {
      api.createRecord('1cd67324', component.options)
    } else {
      api.reload('1cd67324', component.options)
    }
    module.hot.accept("./result.vue?vue&type=template&id=1cd67324&scoped=true&", function () {
      api.rerender('1cd67324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/region/search/result.vue"
export default component.exports